// extracted by mini-css-extract-plugin
export default {"root":"IconDate_root__d6exj"};